module.exports = __webpack_public_path__ + "static/media/face-with-hand-over-mouth-svgrepo-com.fe40f633.svg";